import { Directive, Output, EventEmitter, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[debounce]'
})
export class DebounceDirective {
  @Input() delay: number = 300;
  @Input() canEnter: boolean = true;
  @Input() alwaysHandleEmpty: boolean = true;
  @Output() text: EventEmitter<string> = new EventEmitter<string>();

  lastValue: string = '';
  timeout: any;

  handleChange(value: string) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.text.emit(value);
    }, this.delay);
  }

  @HostListener('keyup', ['$event'])
  handleKeyup(event: any) {
    const value: string = event.target.value || '';
    if((this.alwaysHandleEmpty && value == '') || value != this.lastValue) {
      this.lastValue = value;
      this.handleChange(value);
    }
  }

  @HostListener('keydown.enter', ['$event'])
  handleEnter(event: any) {
    if(!this.canEnter)
      return;
    const value = event.target.value;
    clearTimeout(this.timeout);
    this.lastValue = value;
    this.text.emit(value);
  }
}